import React, { ReactNode } from "react";

import { SxProps, Typography } from "@mui/material";

export interface HeadingProps {
  sx?: SxProps;
  children?: string | null;
}

export interface ParagraphProps {
  sx?: SxProps;
  children?: ReactNode;
}

export const Heading1 = (props: HeadingProps) => (
  <Typography variant="h1" sx={{ pt: 2, pb: 3, ...props.sx }}>
    {props.children}
  </Typography>
);

export const Heading2 = (props: HeadingProps) => (
  <Typography variant="h2" sx={{ pt: 1.5, pb: 2, ...props.sx }}>
    {props.children}
  </Typography>
);

export const Heading3 = (props: HeadingProps) => (
  <Typography variant="h3" sx={{ pt: 1.5, pb: 2, ...props.sx }}>
    {props.children}
  </Typography>
);

export const Heading4 = (props: HeadingProps) => (
  <Typography variant="h4" sx={{ pb: 4, ...props.sx }}>
    {props.children}
  </Typography>
);

export const Heading5 = (props: HeadingProps) => (
  <Typography variant="h5" sx={{ pb: 3, ...props.sx }}>
    {props.children}
  </Typography>
);

export const Heading6 = (props: HeadingProps) => (
  <Typography variant="h6" sx={{ pb: 2, ...props.sx }}>
    {props.children}
  </Typography>
);

export const Paragraph = (props: ParagraphProps) => (
  <Typography variant="body1" sx={{ pb: 2, ...props.sx }}>
    {props.children}
  </Typography>
);
